import Vue from "vue";
import {Location} from "vue-router";
import lockstepDebounce from "~/lockstepDebounce";

export interface IQueryOptions {
  clear?: string[]
  mode?: 'push' | 'replace'
}

export default Vue.extend({
  data: function () {
    return {
      pushRouteDebounce: null,
      pushRouteQueryDebounce: null
    };
  },
  beforeMount() {
    this.pushRouteDebounce = lockstepDebounce(this.pushRoute, window.AppConfig.queryTimeout());
    this.pushRouteQueryDebounce = lockstepDebounce(this.pushRouteQuery, window.AppConfig.queryTimeout());
  },
  computed: {
    routeParent() {
      return this.$router.options.routes.find(r => r.name === this.$route.meta.parent);
    },
    childRoutes() {
      if (this.routeParent) {
        return this.routeParent.children;
      } else {
        return [];
      }
    }
  },
  methods: {
    buildQuery(query: Location["query"] = {}, options: IQueryOptions = {}) {
      const finalQuery = Object.assign({}, this.$route.query, query);
      const clear = options.clear || []
      clear.forEach(param => {
        delete finalQuery[param];
      });
      return finalQuery;
    },
    appendQuery(query: Location["query"], options: IQueryOptions = {}) {
      options.mode = options.mode || 'push'
      if (options.mode === 'replace') {
        this.replaceRouteQuery(this.buildQuery(query, options));
      } else {
        this.pushRouteQuery(this.buildQuery(query, options));
      }
    },
    pushRoute(location: Location) {
      this.$router.push(location);
    },
    pushRouteQuery(query: Location["query"]) {
      this.$router.push({query: query});
    },
    replaceRouteQuery(query: Location["query"]) {
      this.$router.replace({query: query});
    },
    routeIs(...names: string[]): boolean {
      return names.includes(this.$route.name);
    },
    routeQueryValue(key: string): string {
      return this.$route.query[key];
    },
    hasRouteParam(key: string, value?: string): boolean {
      const queryVal = this.routeQueryValue(key);
      return value ? queryVal === value : queryVal?.length > 0;
    }
  }
});